export const TEAM_AUTONOMY_STEPS = ["supervised", "autonomous", "autonomous_auto_merge"];
/** The lines the ladder sets: Bailey's proposals, Reeve's plans, Wright's builds, Proctor's reviews. */
export const TEAM_LADDER_LINE_KINDS = [
    "pm.propose",
    "staff.plan",
    "builder.build",
    "reviewer.review_pr",
];
export function isTeamAutonomy(value) {
    return typeof value === "string" && TEAM_AUTONOMY_STEPS.includes(value);
}
export function isTeamLadderLineKind(kind) {
    return TEAM_LADDER_LINE_KINDS.includes(kind);
}
/** What a step sets: every ladder line's rung and the Team's "Merge automatically" switch. */
export function ladderSettingsFor(step) {
    if (step === "supervised")
        return { authority: "supervised", autoMerge: false };
    return { authority: "autonomous", autoMerge: step === "autonomous_auto_merge" };
}
/** The ladder lines that act: of the four kinds, and switched on. */
function ladderLinesOn(lines) {
    return lines.filter((line) => line.active && isTeamLadderLineKind(line.kind));
}
/**
 * The step a Team's lines describe, for a Team nobody has picked a step on:
 * every ladder line that is on is Autonomous and the switch is on, then
 * `autonomous_auto_merge`; every one Autonomous, then `autonomous`; anything
 * else, including no ladder line on at all, `supervised`.
 */
export function deriveTeamAutonomy(lines, autoMerge) {
    const on = ladderLinesOn(lines);
    const allAutonomous = on.length > 0 && on.every((line) => line.authority === "autonomous");
    if (!allAutonomous)
        return "supervised";
    return autoMerge ? "autonomous_auto_merge" : "autonomous";
}
/** Whether the lines and the switch are exactly what a step sets. */
export function teamMatchesStep(step, lines, autoMerge) {
    const want = ladderSettingsFor(step);
    if (want.autoMerge !== autoMerge)
        return false;
    return ladderLinesOn(lines).every((line) => (line.authority ?? "supervised") === want.authority);
}
/** The step a Team reads as, and whether its lines were set apart from it. */
export function readTeamLadder(stored, lines, autoMerge) {
    const step = isTeamAutonomy(stored) ? stored : deriveTeamAutonomy(lines, autoMerge);
    return { step, override: !teamMatchesStep(step, lines, autoMerge) };
}
//# sourceMappingURL=teamLadder.js.map